import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {isUndefined,isEmpty} from 'lodash'
import {useSelector} from 'react-redux'
import IntlMessages from 'util/IntlMessages';

const currencies = [
    {value: 0,disabled:true,label: <IntlMessages id="Choose"/>,},
    {value: 'Mail',disabled:false,label: <IntlMessages id="Activities.Type.option1"/>,},
    {value: 'Ring',disabled:false,label: <IntlMessages id="Activities.Type.option2"/>,},
    {value: 'Säljsamtal',disabled:false,label: <IntlMessages id="Activities.Type.option3"/>,},
    {value: 'Anteckning',disabled:false,label: <IntlMessages id="Activities.Type.option4"/>,},
    {value: 'Övrigt',disabled:false,label: <IntlMessages id="Other"/>,},
];
const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

function AktivitetsTyp(props) {
    const classes = useStyles();
    const AktivitetTypeList = useSelector(state => state.accountsData.AktivitetTypeList)
    const [Type, settype] = React.useState(props.Type);
    console.log("AktivitetsTyp",props.Type,Type)
    console.log("AktivitetsTyp AktivitetTypeList",AktivitetTypeList)
    const handleChange = (event) => {
        settype(event.target.value);
        props.onchangeHanelAktivitet("type",event.target.value)
    };
    return (
        <form className={classes.root}>
            <div>
                <TextField
                    label={<IntlMessages id="appKontoModule.Type"/>}
                    select
                    variant="outlined"
                    size="small"
                    value={Type}
                    error={Type===0}
                    fullWidth
                    onChange={handleChange}
                    SelectProps={{
                        native: true,
                    }}
                >
                    {
                        !isEmpty(AktivitetTypeList)?
                        <>
                         <option key={0} disabled={true} value={0}><IntlMessages id="Choose"/></option>
                         {
                            AktivitetTypeList.map(item=>{
                                return <option key={item.id} disabled={false} value={item.Value}>{item.Meta}</option>
                            })
                         }
                        </>
                        :
                    currencies.map((option) => (
                        <option key={option.value} disabled={option.disabled} value={option.value}>
                            {option.label}
                        </option>
                    ))
                    }
                </TextField>
            </div>
        </form>
    );
}
export default AktivitetsTyp;